import { render, staticRenderFns } from "./PriceDetail.vue?vue&type=template&id=a5a2ca5e&scoped=true&"
import script from "./PriceDetail.vue?vue&type=script&lang=js&"
export * from "./PriceDetail.vue?vue&type=script&lang=js&"
import style0 from "./PriceDetail.vue?vue&type=style&index=0&id=a5a2ca5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a2ca5e",
  null
  
)

export default component.exports